import { request } from './utils/api'
import { HTTPMethod, type Response } from './utils/api.types'

interface GetUploadUrlRequest {
  object_id: string
  identifier?: string
  filename: string
  token?: string
  presenter_token?: string
}

interface GetUploadUrlResponse extends Response {
  data: {
    expires: number
    upload_url: string
    download_url: string
  }
}

type GetUploadUrlOptions = {
  objectId: string
  identifier?: string
  filename: string
  token?: string
  presenterToken?: string
}

interface ObjectAssetUrls {
  expiresIn: number
  uploadUrl: string
  downloadUrl: string
}

function mapGetObjectAssetUploadUrlResponse(
  response: GetUploadUrlResponse
): ObjectAssetUrls {
  return {
    expiresIn: response.data.expires,
    uploadUrl: response.data.upload_url,
    downloadUrl: response.data.download_url,
  }
}

function getObjectAssetUploadUrl({
  objectId,
  identifier,
  filename,
  token,
  presenterToken,
}: GetUploadUrlOptions) {
  return request<GetUploadUrlRequest, GetUploadUrlResponse>({
    url: '/api/2/object-asset/get-upload-url',
    method: HTTPMethod.GET,
    data: {
      object_id: objectId,
      identifier,
      filename,
      token,
      presenter_token: presenterToken,
    },
  })
}

interface UploadGuestSpeakerPreviewOptions {
  objectId: string
  joinToSpeakID: string
  presenterToken: string
  blob: Blob
}

async function uploadGuestSpeakerPreview({
  objectId,
  joinToSpeakID,
  presenterToken,
  blob,
}: UploadGuestSpeakerPreviewOptions) {
  const getObjectAssetUploadUrlResponse = await getObjectAssetUploadUrl({
    objectId,
    identifier: joinToSpeakID,
    filename: 'guest-speaker-preview.jpg',
    presenterToken,
  })

  const { uploadUrl } = mapGetObjectAssetUploadUrlResponse(
    getObjectAssetUploadUrlResponse
  )

  const headers = new Headers()
  headers.append('Content-Type', 'image/jpeg')
  headers.append('Cache-Control', 'no-cache')

  const uploadResponse = await fetch(uploadUrl, {
    method: 'PUT',
    headers,
    body: blob,
  })

  return uploadResponse
}

export {
  getObjectAssetUploadUrl,
  mapGetObjectAssetUploadUrlResponse,
  uploadGuestSpeakerPreview,
}
